<div class="row seedfullPage proving-ground-seed-order-create">
  <div class="seedEfulfillmentOuter" id="orderView">

    <div class="seedEfulfillment">
      <div class="order-view-sec breadcrumbOuter padding-0">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToLanding()">Proving Ground Seed</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item" *ngIf="orderHeaderId<=0">
              <span>Create Order</span>
            </li>
            <li class="breadcrumb-item breadcrumbColor" aria-current="page" *ngIf="orderHeaderId>0">
              <span>{{pgsOrder.OrderNumber}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="OrderReleaseTop">
        <div *ngIf="error">
          <div class="row">
            <div class="col-md-12">
              <div class="inline-error" *ngIf="error">
                <div class="row">
                  <div class="col-md-12 padding-l0">
                    <ol class="error-list">
                      <li class="justify-content-center align-self-center" *ngFor="let err of errorsList">
                        {{err}}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Ship to - Confirmation Email Section-->
        <div class="row justify-content-between">
          <div class="col-md-3 material-select withBordr pr-0 readOnly">
            <ng-select name="ddlSalesManager"
                       [items]="salesManagerAccounts"
                       class="custom-select-grower grower-add-drop pb-0 associate-crop-select"
                       [(ngModel)]="pgsOrder.SalesManagerAccount"
                       [virtualScroll]="true"
                       [loading]="shipToDataLoading"
                       bindLabel="accountNameCityState"
                       placeholder="Sales Manager:"
                       bindValue="accountNumber"
                       [disabled]="isDisabled(true)"
                       [closeOnSelect]="true"
                       (change)=getSalesManager($event)>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-4">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountNumber}} - {{item.accountName}}
                      </h4>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class=" col-md-3 material-select withBordr p-0 readOnly">
            <ng-select name="ddlShipTo"
                       [items]="shipToData"
                       class="custom-select-grower grower-add-drop pb-0 associate-crop-select"
                       [virtualScroll]="true"
                       [(ngModel)]="pgsOrder.ShipToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Ship To:"
                       [closeOnSelect]="true"
                       [loading]="locationDataLoading"
                       [searchFn]="accountSearchFn"
                       (change)="getShipTo($event)"
                       (clear)="getShipTo($event)"
                       [disabled]="isDisabled(false)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div class="shipTo">
              <div *ngIf="selectedDealer">
                <p>
                  Account#: {{selectedDealer.accountNumber}}
                </p>
                <p>
                  Address: {{selectedDealer.address1}},  {{selectedDealer.city}}, {{selectedDealer.state}} - {{selectedDealer.zipCode}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3 material-select nonRequired withBordr readOnly">
            <ng-select name="ddlDeliverTo"
                       [items]="deliverToData"
                       class="custom-select-grower grower-add-drop pb-0 associate-crop-select"
                       [virtualScroll]="true"
                       [(ngModel)]="pgsOrder.DeliverToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Deliver To:"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       [disabled]="readOnlyAccess || !pgsOrder.DeliverToAnotherLocation || disableDeliverTo"
                       (change)="getDeliverToAccount($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div class="shipTo">
              <div *ngIf="deliverTo">
                <p>
                  Account#: {{deliverTo.accountNumber}}
                </p>
                <p>
                  Address: {{deliverTo.address1}},  {{deliverTo.city}}, {{deliverTo.state}} - {{deliverTo.zipCode}}
                </p>
              </div>
            </div>
            <div class="checkbox-color checkbox-alignment">
              <mat-checkbox class="custom-checkbox p-0"
                            [disabled]="readOnlyAccess || disableDeliverTo"
                            [style.display]=""
                            [indeterminate]=""
                            (change)="markDataChanged('deliverToUpdated'); removeDeliverTo()"
                            [(ngModel)]="pgsOrder.DeliverToAnotherLocation"
                            data-testid="ddl-deliver-to-checkbox">I want this delivered to another location.</mat-checkbox>
            </div>
          </div>
        </div>
        <div class="row">

        </div>
        <div class="row justify-content-between">
          <div class="col-md-3 material-select withBordr mt-3 pr-0 readOnly">
            <ng-select name="ddlProductLine"
                       [items]="productLineData"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       bindLabel="value"
                       placeholder="Product Line"
                       bindValue="id"
                       (change)="getProductLineChange()"
                       (clear)="getProductLineChange()"
                       [(ngModel)]="pgsOrder.ProductLine"
                       [closeOnSelect]="true"
                       [disabled]="isDisabled(false) || !(pgsOrder.SalesManagerAccount && pgsOrder.ShipToAccount)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-4">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.value}}
                      </h4>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-3 customerPO p-0">
            <mat-form-field class="wide100">
              <mat-label>Customer PO:</mat-label>
              <input matInput type="text" name="customerPO" class="pb-1"
                     [(ngModel)]="pgsOrder.CustomerPO"
                     [readonly]="readOnlyAccess"
                     [disabled]="(readOnlyAccess)"
                     [maxLength]="25"
                     autocomplete="off"
                     (input)="markDataChanged('cppPOValue')"
                     (change)="enableDisablePlaceOrder()">
            </mat-form-field>
          </div>
          <div class="col-md-3 deliveryNotes material-select d-flex justify-content-start p-0">
            <mat-form-field class="wide100 col-md-11">
              <mat-label>Delivery Instructions:</mat-label>
              <input matInput type="text" name="deliveryInstructionsCodes" class="pb-1" data-testid="btn-delivery-instructions-codes"
                     [(ngModel)]="pgsOrder.DeliveryInstructionsCodes"
                     [readonly]="readOnlyAccess"
                     [disabled]="(readOnlyAccess)"
                     [maxLength]="30"
                     autocomplete="off"
                     (input)="markDataChanged('deliveryInstructionsUpdated')"
                     (change)="enableDisablePlaceOrder()">
            </mat-form-field>
          </div>
        </div>
        <div class="row justify-content-between align-items-center">
          <div class="col-md-3">
            <!--<mat-form-field>
              <mat-label>Requested By Date</mat-label>
              <input matInput [readonly]="true" [matDatepicker]="picker" (dateChange)="validateDate($event)" [(ngModel)]="pgsOrder.RequestedDate" placeholder="Requested Date" (focus)="picker.open();" [min]="minDate" [max]="maxDate" [matDatepickerFilter]="dateFilter">
              <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="readOnlyAccess"></mat-datepicker-toggle>
              <mat-datepicker #picker [disabled]="readOnlyAccess"></mat-datepicker>
            </mat-form-field>-->
          </div>
          <div class="col-md-3 checkbox-color d-flex align-items-center p-0">
            Customer Pickup:  <mat-checkbox #CustomerPickupCheck class="custom-checkbox margin-l10"
                                            [style.display]=""
                                            [indeterminate]=""
                                            [(ngModel)]="pgsOrder.IsCustomerPickup"
                                            [disabled]="(readOnlyAccess)"
                                            matTooltip="Select For Customer Pickup" [matTooltipPosition]="'above'"
                                            data-testid="ddl-customer-pickup"
                                            (change)="markDataChanged('cppCustPickupValue'); enableDisablePlaceOrder()"></mat-checkbox>
          </div>
          <div class="col-md-3 d-flex align-items-center justify-content-between">
            <div class="checkbox-color checkbox-alignment d-flex align-items-center mr-3">
              <mat-checkbox #DisplayZeroLinesCheck class="custom-checkbox"
                            [style.display]=""
                            [indeterminate]=""
                            (change)="filterData(DisplayZeroLinesCheck._checked);"
                            [(ngModel)]="pgsOrder.IsLinesGreaterThanZero"
                            [disabled]="(readOnlyAccess || IsLinesGreaterThanZeroDisable)"
                            matTooltip="Display Line(s) with Order Quantity > 0" [matTooltipPosition]="'above'"
                            data-testid="chk-display-Zero-Lines-Check">Display Line(s) with Order Quantity > 0:</mat-checkbox>
            </div>
            <div *ngIf="!readOnlyAccess && !isOrderEditable" class="customerPO">
              <button mat-raised-button class="btns" [disabled]="!pgsOrder.SalesManagerAccount || !pgsOrder.ProductLine || !pgsOrder.ShipToAccount || (pgsOrder.DeliverToAnotherLocation && deliverToData?.length > 0 && !pgsOrder.DeliverToAccount)" (click)="getProductsList($event)" data-testid="btn-compute-inventory2">Display</button>
            </div>
          </div>
        </div>
      </div>

      <div class="OrderReleaseDetail">
        <!--Product Detail section-->
        <div class="form-sec">

          <div class="row margin-r0 margin-b20">
            <div class="col-md-11 product-filter-outer">
              <div class="product-filter-outer">
                <div class="product-filter col-md-12">
                  <div class="search-category">
                    <div class="brand-dropdown default-select agent-crop-select">
                      <ng-select [items]="searchTypeList"
                                 name="ddlProductSearch"
                                 [(ngModel)]="productSearchFilter"
                                 [virtualScroll]="true"
                                 [closeOnSelect]="true"
                                 [selectOnTab]="true"
                                 [clearable]="false"
                                 bindLabel="name"
                                 bindValue="value"
                                 [searchable]="false"
                                 (change)="keepFilter()"
                                 placeholder="Select Category">
                      </ng-select>
                    </div>
                  </div>
                  <div class="search-box">
                    <div class="row margin-0">
                      <div class="default-select select-container">
                        <div *ngIf="productSearchFilter === 'PackName'">
                          <div class="searchInputBox">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input class="custom-select-grower"
                                     [(ngModel)]="productFilters.PackName"
                                     placeholder="Search..." (keyup.enter)="enableSearchButton && onSearchClick()">
                            </div>
                          </div>
                        </div>
                        <div *ngIf="productSearchFilter === 'Variety'">
                          <div class="searchInputBox">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input class="custom-select-grower"
                                     [(ngModel)]="productFilters.Variety"
                                     placeholder="Search..." (keyup.enter)="enableSearchButton && onSearchClick()">
                            </div>
                          </div>
                        </div>
                        <div class="agent-crop-select" *ngIf="productSearchFilter === 'ItemNumber'">
                          <ng-select name="ddlItemNumberSearch"
                                     [items]="uniqueItemList"
                                     placeholder="Search Item Number"
                                     class="custom-select-grower"
                                     [multiple]="true"
                                     [hideSelected]="true"
                                     [(ngModel)]="productFilters.ItemNumberList"
                                     [virtualScroll]="true"
                                     bindLabel="itemNumber"
                                     bindValue="itemNumber"
                                     [closeOnSelect]="true"
                                     (change)="keepFilter()">
                            <ng-template ng-option-tmp let-item="item">
                              <div class="dropdown-template">
                                <p class="name">{{item.itemNumber}}</p>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="row chips-sec" *ngIf="filterValueList != '' ">
                  <div class="col-sm-9 col-md-10 selected-chip">
                    <mat-chip-set>
                      <mat-chip selected *ngFor="let filterValue of filterValueList">
                        {{filterValue}}
                        <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                          <i class="fas fa-times text-right"></i>
                        </a>
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                  <div class="col-sm-3 col-md-2 text-right">
                    <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1">
              <button mat-raised-button (click)="onSearchClick()" *ngIf="enableSearchButton" class="btns">Search</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer">

              <table mat-table [dataSource]="pgsOrderSource" multiTemplateDataRows class="matTables productTable">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='packName'"><th mat-header-cell *matHeaderCellDef class="text-center">Pack Name</th>
            </div>
            <div *ngIf="column=='allocatedQuantity'"><th mat-header-cell *matHeaderCellDef class="text-center">Allocated Quantity</th></div>
            <div *ngIf="column=='availableQuantity'"><th mat-header-cell *matHeaderCellDef class="text-center">Available Quantity</th></div>
            <div *ngIf="column=='orderQuantity'"><th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity">Order Quantity</th></div>
            <!--<div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="text-center">UOM</th> </div>-->
            <div *ngIf="column=='status'"><th mat-header-cell *matHeaderCellDef class="text-center">Status</th> </div>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="column=='packName'" class="text-center">
                <div class="order-info handCursor" (click)="openPackDetails(element)">
                  <u>
                    <p class="accNo">
                      {{element.packName}}
                    </p>
                  </u>
                </div>
              </div>
              <div *ngIf="column=='allocatedQuantity'" class="text-center">
                <div>
                  <p class="mb-0">{{element.allocatedQuantity}}</p>
                </div>
              </div>

              <div *ngIf="column=='availableQuantity'" class="available-block text-center">
                <div>
                  <span> {{element.availableQuantity}}</span>
                </div>
              </div>

              <div *ngIf="column=='orderQuantity' && !readOnlyAccess" class="text-center">
                <div *ngIf="element.active == true">
                  <button (click)="OrderUnitChange('decrease',element)" class="plus-minus-btn minusBtn"> - </button>
                  <input type="text" class="geu-txt padding-t2" [(ngModel)]="element.orderQuantity" (focusout)="enableDisablePlaceOrder()" (keyup)="quantityTextChange(element)" maxlength="15" appNumbersOnly />
                  <button (click)="OrderUnitChange('increase',element)" class="plus-minus-btn plusBtn"> + </button>
                </div>
                <div *ngIf="element.active == false" class="text-center">
                  <div>
                    <span> {{element.orderQuantity}}</span>
                  </div>
                </div>
              </div>
              <div *ngIf="column=='orderQuantity' && readOnlyAccess" class="text-center">
                <div>
                  <span> {{element.orderQuantity}}</span>
                </div>
              </div>
              <!--<div *ngIf="column=='uom'" class="text-center">
               <div>
                 <span> {{element.uom}}</span>
               </div>
              </div>-->

              <div *ngIf="column=='status' && (readOnlyAccess || isOrderEditable)" class="text-center">
                <div>
                  <span class="geu-txt padding-t2"> {{element.status}}</span>
                </div>
              </div>
            </td>
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div class="inline-error mb-0" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                  <div class="row">
                    <div class="col-md-9">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors">
                          {{err.error}}
                      </ol>
                    </div>
                    <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" [ngClass]="{'sticky-header-row':!readOnlyAccess}"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
            <div *ngIf="pgsOrderSource == undefined || (pgsOrderSource && pgsOrderSource.data.length == 0)" class="noDataMsg">
              <p class="padding-b47">No Record Found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="common-error-block" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index].errors.length > 0">
    <div class="row">
      <div class="col-md-2 padding-r0 errCountOuter">
        <!--<span class="close-icon">
          <i class="icon-ico-Error"></i>
        </span>-->
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-md-6 padding-l0 ">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p> {{err.error}}</p>
          </li>
        </ul>
      </div>
      <div class="col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()" data-testid="btn-revert-errors">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()" data-testid="btn-next-error">Next Error</button>
      </div>
    </div>
  </div>
  <div class="SeedFulfillBtnSec">
    <div class="row">
      <div class="col-md-12">
        <button *ngIf="!readOnlyAccess" mat-raised-button class="btns" [disabled]="isPlaceOrderDisable" data-testid="btn-place-order" (click)="placeOrder()">{{ isOrderEditable ? 'Update Order' : 'Place Order' }}</button>
        <button *ngIf="!readOnlyAccess" mat-raised-button class="btns" color="primary" (click)="navigateToLanding()" data-testid="btn-seed-crop-associates-cancel">Cancel</button>
        <button *ngIf="readOnlyAccess" mat-raised-button class="btns" color="primary" (click)="navigateToLanding()" data-testid="btn-seed-crop-associates-back">Back to View Orders</button>
      </div>
    </div>
  </div>

  <div class="pack-modal-backdrop" *ngIf="showPackModal">
    <div class="pack-modal-body" role="dialog" aria-modal="true" aria-labelledby="pack-modal-title">
      <div class="pack-modal-header">
        <h4 id="pack-modal-title" class="m-0">{{selectedPackName}}</h4>
        <button type="button" class="pack-modal-close" (click)="closePackModal()" aria-label="Close">
          <span class="pack-close-icon" aria-hidden="true"></span>
        </button>
      </div>

      <div class="tableContainer">
        <table mat-table [dataSource]="selectedPackDetails" class="matTables containerDrafTable pack-table">
          <ng-container matColumnDef="itemNumber">
            <th mat-header-cell *matHeaderCellDef class="text-center">Item Number</th>
            <td mat-cell *matCellDef="let element" class="text-center">{{element.itemNumber}}</td>
          </ng-container>

          <ng-container matColumnDef="hybridVariety">
            <th mat-header-cell *matHeaderCellDef class="text-center">Hybrid Variety</th>
            <td mat-cell *matCellDef="let element" class="text-center">{{element.hybridVariety}}</td>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef class="text-center">Quantity</th>
            <td mat-cell *matCellDef="let element" class="text-center">{{element.quantity}}</td>
          </ng-container>

          <ng-container matColumnDef="uom">
            <th mat-header-cell *matHeaderCellDef class="text-center">UOM</th>
            <td mat-cell *matCellDef="let element" class="text-center">{{element.uom}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="packDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: packDisplayedColumns"></tr>
        </table>
        <div class="noRecordMsg" *ngIf="selectedPackDetails.length == 0">No Record Found.</div>
      </div>
    </div>
  </div>
</div>
